import ZoomLP from 'containers/CollectionPage/HardCode/Zoom';
import { NextSeo } from 'next-seo';

const ZoomLPPage = () => (
  <>
    <NextSeo
      title="Zoom Meeting/Workplace Premium | Xooply.ID"
      description="Layanan produk Zoom di Xooply dirancang untuk memberikan kemudahan dan efisiensi bagi kebutuhan operasional Anda. Belanja melalui Xooply memastikan Anda mendapatkan penawaran terbaik"
    />

    <ZoomLP />
  </>
);

export default ZoomLPPage;
